<template>
  <div>
        <v-toolbar flat color="white">
            <v-toolbar-title>SPC마스터</v-toolbar-title>
            <v-spacer/>
            <v-dialog
                    v-model="dialog"
                    persistent
                    width="600px"
                    height="600px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">추가하기</v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-select
                                    v-model="editedItem.threshold"
                                    :items="thresholdItem"
                                    item-text="caption"
                                    item-value="code"
                                    label="기준값"
                                    persistent-hint
                                    return-object
                            ></v-select>
                            <v-row class="px-3">
                                <v-text-field v-model="editedItem.usl" type="number" label="규격상한"/>
                                <v-text-field v-model="editedItem.lsl" type="number" label="규격하한"/>
                            </v-row>
                            <v-row class="px-3">
                                <v-text-field v-model="editedItem.ucl" type="number" label="관리상한"/>
                                <v-text-field v-model="editedItem.lcl" type="number" label="관리하한"/>
                            </v-row>
                            <v-row class="px-3">
                                <v-select
                                    v-model="editedItem.item"
                                    :items="[{name:'온도',value:'temperature'}, {name:'습도', value:'humidity'}]"
                                    item-text="name"
                                    item-value="value"
                                    label="관리항목"
                                    persistent-hint
                                ></v-select>
                            </v-row>
                            <v-select
                                    v-model="editedItem.anomaly"
                                    :items="anomaly"
                                    label="이상현상"
                                    item-text='caption'
                                    item-value='code'
                                    return-object
                                    multiple
                            >
                                <template slot="selection" slot-scope="{ item }">
                                    {{ item.code }}
                                </template>
                                <template v-slot:prepend-item>
                                    <v-list-item
                                            ripple
                                            @click="anomalyToggle"
                                    >
                                        <v-list-item-action>
                                            <v-icon :color="editedItem.anomaly.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>Select All</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                            </v-select>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="primary" @click="saveItem">저장</v-btn>
                        <v-btn color="primary" @click="close">취소</v-btn>
                    </v-card-actions>

                </v-card>

            </v-dialog>
        </v-toolbar>
      <v-data-table
              :headers="headers"
              :items="DataList"
              sort-by="LOT"
      >

        <template v-slot:item.action="{ item }">
              <v-btn color="primary" small @click="editItem(item)" class="ma-1">
                  <v-icon
                          left
                          small
                  >
                      mdi-border-color
                  </v-icon>
                  <span>수정</span>
              </v-btn>
              <v-btn color="primary" small @click="deleteItem(item)" class="ma-1">
                  <v-icon
                          left
                          small
                  >
                      mdi-eraser-variant
                  </v-icon>
                  <span>삭제</span>
              </v-btn>

        </template>

      </v-data-table>

  </div>
</template>

<script>
export default {
  name: 'SPCMaster',

  data: () => ({
    dialog: false,
    thresholdItem: [
      { caption: '양쪽규격', code: 'both' },
      { caption: '한쪽규격 (Max)', code: 'top' },
      { caption: '한쪽규격 (Min)', code: 'bottom' }
    ],

    headers: [
      { text: '기준값',
        value: 'threshold.caption'
      },
      { text: '규격상한',
        value: 'usl'
      },
      { text: '규격하한',
        value: 'lsl'
      },
      { text: '관리상한',
        value: 'ucl'
      },
      { text: '관리하한',
        value: 'lcl'
      },
      { text: '관리항목',
        value: 'item'
      },
      { text: '이상현상',
        value: 'anomalys'
      },
      { text: '',
        align: 'right',
        value: 'action',
        sortable: false
      }
    ],
    DataList: [],
    anomaly: [
      { caption: 'A : 관리한계선 벗어남', code: 'A' },
      { caption: 'B : 중심선 한쪽으로만 9개점', code: 'B' },
      { caption: 'C : 연속 6점이 증가, 감소', code: 'C' },
      { caption: 'D : 연속 14점이 증가, 감소 반복', code: 'D' },
      { caption: 'E : 연속 3점 중 2점이 어느 한쪽(±3σ)', code: 'E' },
      { caption: 'F : 연속 5점 중 4점이 ±1σ, ±2σ', code: 'F' },
      { caption: 'G : 연속한 15점이 ±1σ', code: 'G' },
      { caption: 'H : 연속 8점이  ±1σ, ±2σ', code: 'H' }
    ],
    editedIndex: -1,
    editedItem: {
      id: '',
      lot: '',
      threshold: { caption: '양쪽', code: 'both' },
      usl: 0,
      lsl: 0,
      ucl: 0,
      lcl: 0,
      sample: 0,
      item: '',
      anomaly: [],
      anomalys: '',
      unit: '',
      customer: {}
    },
    defaultItem: {
      id: '',
      lot: '',
      threshold: { caption: '양쪽', code: 'both' },
      usl: 0,
      lsl: 0,
      ucl: 0,
      lcl: 0,
      sample: 0,
      item: '',
      anomaly: [],
      anomalys: '',
      unit: '',
      customer: {}
    }
  }),

  created () {
    this.getItemList()
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? '추가하기' : '수정하기'
    },
    likesAllAnomaly () {
      return this.editedItem.anomaly.length === this.anomaly.length
    },
    likesSomeAnomaly () {
      return this.editedItem.anomaly.length > 0 && !this.likesAllAnomaly
    },
    icon () {
      if (this.likesAllAnomaly) return 'mdi-close-box'
      if (this.likesSomeAnomaly) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  methods: {

    getItemList () {
      // DB 리스트 가져오기.
      this.DataList = []
      this.$axios.get('/api/spcstandards', this.$Common.headerApiRequest())
        .then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            /*
              이상 현상 문자열 생성
            */
            res.data[i].anomalys = []
            if (typeof res.data[i].anomaly !== 'undefined' && res.data[i].anomaly.length>0) {
              for (let j = 0; j < res.data[i].anomaly.length; j++) {
                if (typeof res.data[i].anomaly[j].code !== 'undefined') {
                  res.data[i].anomalys.push(res.data[i].anomaly[j].code)
                }
              }
            }
            this.DataList.push(res.data[i])
          }
        })
        .catch((e) => {
          console.log('failed get spcstandards -> ' + JSON.stringify(e.response.data))
        })
    },

    anomalyToggle () {
      this.$nextTick(() => {
        if (this.likesAllAnomaly) {
          this.editedItem.anomaly = []
        } else {
          this.editedItem.anomaly = this.anomaly.slice()
        }
      })
    },

    saveItem () {
      if (this.editedItem.item.length === 0) {
        this.$dialog.alert('관리항목을 입력해 주세요.', { okText: '확인' }).then(function (dialog) {
        })
        return
      }

      if (this.editedIndex > -1) {
        // SPC 마스터 수정.
        this.$axios.put('/api/spcstandards', this.editedItem, this.$Common.headerApiRequest())
        .then((res) => {
          Object.assign(this.DataList[this.editedIndex], this.editedItem)
          this.close()
          this.$dialog.alert('SPC 마스터가 수정 되었습니다.', { okText: '확인' }).then(function () {
          })
        })
        .catch((e) => {
          console.log('failed put spcstandards -> ' + JSON.stringify(e.response.data))
        })
      } else {
        // SPC 마스터 추가.
        this.$axios.post('/api/spcstandards', this.editedItem, this.$Common.headerApiRequest())
        .then((res) => {
          this.DataList.push(this.editedItem)
          this.close()
          this.$dialog.alert('SPC 마스터가 추가 되었습니다.', { okText: '확인' }).then(function () {
          })
        })
        .catch((e) => {
          console.log('failed post spcstandards -> ' + JSON.stringify(e.response.data))
        })
      }
    },

    deleteItem: function (item) {
      // SPC 마스터 삭제.
      const self = this
      this.$dialog
        .confirm('이 정보를 삭제하시겠습니까?', { okText: '확인', cancelText: '취소' })
        .then(function () {
          self.$axios.delete('/api/spcstandards/' + item.id, self.$Common.headerApiRequest())
          .then(() => {
            self.$dialog.alert('SPC 마스터가 삭제 되었습니다.', { okText: '확인' }).then(function () {
              const index = self.DataList.indexOf(item)
              self.DataList.splice(index, 1)
            })
          })
          .catch((e) => {
            console.log('failed delete spcstandards -> ' + JSON.stringify(e.response.data))
          })
        })
        .catch(function () {
        })
    },

    editItem: function (item) {
      this.editedIndex = this.DataList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    }

  }
}
</script>

<style scoped/>
